export default "/_next/static/images/2019-8dc9a9d1b20e0f8fe1afb8b2965beee3.svg";